import {
  FETCH_BRANCHES_SUCCESS,
  FETCH_BRANCH_SUCCESS,
} from '../../constants/ActionTypes'

const initialSettings = {}

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_BRANCHES_SUCCESS: {
      return { ...state, index: action.payload }
    }
    case FETCH_BRANCH_SUCCESS: {
      return { ...state, show: action.payload }
    }
    default:
      return state
  }
}
